import { atom, useAtom } from 'jotai';
import { type StaticImageData } from 'next/image';

type FanTokenItem = {
	amount?: number;
	enabled?: boolean;
	formattedAmount?: string;
	id?: string;
	isCC2Enabled?: boolean;
	isExternalToken?: boolean;
	minAmount?: number;
	partnerName?: string;
	shortCode?: string;
	url?: StaticImageData | string;
};

const fanTokenAtom = atom<FanTokenItem | undefined>(undefined);
const selectedNetworkTypeAtom = atom<string>('');
const currencyIdAtom = atom<string>('');
const inputAmountAtom = atom<string>('');

export const useWithdrawDataAtom = () => {
	const [fanToken, setFanToken] = useAtom(fanTokenAtom);
	const [selectedNetworkType, setSelectedNetworkType] = useAtom(selectedNetworkTypeAtom);
	const [currencyId, setCurrencyId] = useAtom(currencyIdAtom);
	const [inputAmount, setInputAmount] = useAtom(inputAmountAtom);

	return {
		currencyId,
		fanToken,
		inputAmount,
		selectedNetworkType,
		setCurrencyId,
		setFanToken,
		setInputAmount,
		setSelectedNetworkType
	};
};
